import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { PhaseChangeEvent } from 'app/modules/vehicle-inventory/services/inventory-reports.service';
import { Rest } from 'app/rest/rest_client';
import { RestExt } from 'app/services/rest-client-extension';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { BillingaccountService } from 'app/rest/billingaccount.service';
import { CecoService } from "app/rest/ceco.service";
import { DelegationService } from 'app/modules/vehicle-inventory/services/table-management/delegation.service';
import { SubdelegationService } from 'app/rest/subdelegation.service';
import { VehicleService } from 'app/rest/vehicle.service';

import BillingAcount = Rest.BillingAccount;
import Ceco = Rest.Ceco;
import Delegation = Rest.Delegation;
import Subdelegation = Rest.Subdelegation;
import Vehicle = Rest.Vehicle;

import Client = Rest.Client;

@Component({
    selector: 'app-driver-assignments-report-form',
    templateUrl: './driver-assignments-report-form.component.html',
    styleUrls: ['./driver-assignments-report-form.component.css'],
    providers: [
        VehicleService
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DriverAssignmentsReportFormComponent implements OnInit {

  client: Client;

  @Output() phaseChange = new EventEmitter<PhaseChangeEvent>();
  @Input() report: PhaseChangeEvent;

  reportData: Rest.InventoryReport;

  reportForm = new UntypedFormGroup({
    vehicle: new UntypedFormControl(null),
  });

  vehicleRequestContext: Rest.ListPaginationRequest;

  vehicles: Vehicle[] = [];

  isVehicleLoaded: boolean = false;

  selectedVehicles: Vehicle[] = [];

  isVehicleChanged: boolean = false;

  constructor(
    protected authenticationService: AuthenticationService,
    private vehicleService: VehicleService
  ) { }

  ngOnInit(): void {
    this.client = this.authenticationService.user.client;

    this.vehicleRequestContext = RestExt.firstPageRequest();

    this.vehicleRequestContext.filters["clientId"] = [this.client.id.toString()];

    this.fetchData();
  }

  goBack() {
    this.phaseChange.emit({ phase: 1, resetData: true });
    this.reportForm.reset();
  }

  onSubmit() {
    if (this.reportForm.valid) {
      this.toPhase3();
    }
  }

  toPhase3() {
    this.phaseChange.emit({ phase: 3, reportData: this.report.reportData, formData: this.reportForm.value });
  }

  fetchData() {
    this.reportData = this.report.reportData;
    this.fetchVehicles();
  }

  fetchVehicles(nameFilter: string = '') {
    this.vehicleRequestContext = {
      sortBy: 'name',
      sortAsc: true,
      pageSize: 10,
      filters: { name: [nameFilter] },
    } as unknown as Rest.ListPaginationRequest;

    this.vehicleService.getPage(this.vehicleRequestContext).then((p) => {
      this.vehicles = p.entities;
      this.isVehicleLoaded = true;
    });
  }

  onFilterVehicle(event: any) {
    this.fetchVehicles(event.filter ?? '');
  }

}
